import React from "react";
import { ArrowRight, ShieldCheck, Zap, FileText, Mail } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-nm-bg nm-grain font-sans flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-lg rounded-3xl border border-nm-primary/12 bg-nm-surface p-9 sm:p-11 nm-shadow-md text-center" data-testid="payment-cancel-page">
        <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-nm-coral">No charge was made</div>
        <h1 className="font-serif text-3xl sm:text-[2rem] text-nm-ink mt-3 leading-tight">Still thinking it over?</h1>
        <p className="text-nm-neutral mt-3 leading-relaxed">
          That's completely fine — your spot is right where you left it. Whenever you're ready, you can pick up in seconds. No pressure.
        </p>

        <blockquote className="mt-7 rounded-2xl bg-nm-primary/[0.05] border border-nm-primary/10 p-5 text-left">
          <p className="text-[15px] leading-loose text-nm-ink/85 font-serif italic">
            "My favorite part is the sample phrases to use in your conversations. It's not always easy to find the most intentional words in the moment, and this helps me prepare."
          </p>
          <div className="text-[12px] font-semibold uppercase tracking-[0.14em] text-nm-primary mt-3">Manager, Undisclosed Industry</div>
        </blockquote>

        <div className="mt-7 grid sm:grid-cols-3 gap-3 text-left">
          {[
            { icon: Zap, t: "Instant access" },
            { icon: ShieldCheck, t: "Secure Stripe checkout" },
            { icon: FileText, t: "Receipt emailed" },
          ].map((x) => {
            const Icon = x.icon;
            return (
              <div key={x.t} className="flex items-center gap-2 rounded-xl bg-white border border-nm-ink/[0.06] px-3 py-2.5">
                <Icon size={16} className="text-nm-primary shrink-0" />
                <span className="text-[12.5px] font-medium text-nm-ink/80 leading-tight">{x.t}</span>
              </div>
            );
          })}
        </div>

        <a href="/#pricing" data-testid="resume-purchase"
          className="mt-8 w-full inline-flex items-center justify-center gap-2 rounded-full bg-nm-coral px-7 py-4 text-sm font-semibold text-white hover:brightness-105 hover:-translate-y-0.5 transition-[filter,transform] duration-200">
          Resume your purchase <ArrowRight size={16} />
        </a>
        <a href="/" data-testid="back-home"
          className="mt-3 inline-block text-sm font-medium text-nm-primary hover:text-nm-coral transition-colors duration-200">
          Back to the homepage
        </a>

        <p className="text-[13px] text-nm-neutral mt-7 flex items-center justify-center gap-1.5">
          <Mail size={14} className="text-nm-neutral" /> Questions first?{" "}
          <a href="mailto:hello@managemeantexcellence.com" data-testid="cancel-contact-email" className="font-medium text-nm-primary hover:underline">hello@managemeantexcellence.com</a>
        </p>
      </div>
    </div>
  );
}
